/* import __COLOCATED_TEMPLATE__ from './delete-topic-disallowed.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./delete-topic-disallowed.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());